
class EditAccessCards {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.editAccessCardEvents();
    }
    editAccessCardEvents(){
        const thisClass = this;
        /** When user click on edit button redraw modal form and get access card values */
        $(document).on('click', '.edit-access-card', function(e) {
            let accessCardID = this.id;
            let goToStep = $(this).attr("data-kt-stepper-step");
            thisClass.showEditAccessCardModal(accessCardID, goToStep);
        });
        /** If url contains #edit-access-card - show access card modal */
        if(window.location.href.includes('edit-access-card') && new URLSearchParams(window.location.search).get('accessCardID')){
            thisClass.showEditAccessCardModal(new URLSearchParams(window.location.search).get('accessCardID'));
        }
    }
    /** Redraw edit access card form by accessCardID */
    showEditAccessCardModal(accessCardID, goToStep){
        new ModalLoading();
        naja.makeRequest('GET', '/access-cards/?do=getAccessCardInfo', {
            'accessCardID': accessCardID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                let editAccessCardModal = document.getElementById('edit_access_card_modal');

                new AccessCardsForm('frm-generalForms-editAccessCardForm-editAccessCardForm', null, response.accessCardInfo, goToStep);
                $.nette.load();

                /** Create scroll instances - make modal fit in window */
                KTScroll.createInstances();

                this.hideGeneralModals(editAccessCardModal);
                new ModalLoading(editAccessCardModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    hideGeneralModals(editAccessCardModal){
        let editGroupModal = document.getElementById('edit_vpn_user_group_modal');
        if(editGroupModal && editGroupModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editGroupModal).hide();
            new AddBackLinkToModal(editGroupModal, editAccessCardModal);
        }
        let editMemberModal = document.getElementById('edit_team_member_modal');
        if(editMemberModal && editMemberModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editMemberModal).hide();
            new AddBackLinkToModal(editMemberModal, editAccessCardModal);
        }
        let editSystemModal = document.getElementById('edit_system_modal');
        if(editSystemModal && editSystemModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editSystemModal).hide();
            new AddBackLinkToModal(editSystemModal, editAccessCardModal);
        }
    }
}
window.EditAccessCards = EditAccessCards;